import script from "./classSection.vue?vue&type=script&setup=true&lang=js"
export * from "./classSection.vue?vue&type=script&setup=true&lang=js"

import "./classSection.vue?vue&type=style&index=0&id=42d32b1e&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d32b1e"]])

export default __exports__